export default "__VITE_ASSET__DCEI9sVC__"